import { ApiInstance } from '..'
import { Dashboard, FeeRate, TokenDepositConfig } from './type'

export const getFeeRate = () => {
  return ApiInstance.post<FeeRate>('', { cmd: 'apid.estimate_fee' })
}

export const getTokenDepositConfig = () => {
  return ApiInstance.post<{ data: Record<string, TokenDepositConfig> }>('', { cmd: 'apid.deposit_token_info' })
}

export const getDashboard = () => {
  return ApiInstance.post<Dashboard>('', { cmd: 'apid.get_dashboard_info' })
}

export const getGrecaptcha = async (): Promise<string> => {
  return new Promise((resolve) => {
    const init = () => {
      window.grecaptcha.ready(function () {
        window.grecaptcha
          .execute('6Lf2RR8mAAAAAFLVWJwJ-pDIWKHjX1q1q51oJnii', { action: 'submit' })
          .then(function (token) {
            resolve(token)
          })
      })
    }
    const check = () => {
      if (window.grecaptcha) {
        init()
      } else {
        setTimeout(check, 500)
      }
    }
    check()
  })
}
